import { render } from "./RegOnEvent.vue?vue&type=template&id=652dc74a&scoped=true"
import script from "./RegOnEvent.vue?vue&type=script&lang=js"
export * from "./RegOnEvent.vue?vue&type=script&lang=js"

import "./RegOnEvent.vue?vue&type=style&index=0&id=652dc74a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652dc74a"]])

export default __exports__